import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { PropTypes as MobXPropTypes, inject, observer } from 'mobx-react'
import { observable, toJS } from 'mobx'
import Button from '../../shared/components/Button'

const getDefaults = () => ({
  recipient: 'Support',
  subject: '',
  message: ''
})

@inject('auth', 'museum') @observer
class FormPage extends Component {

  static propTypes = {
    auth: MobXPropTypes.observableObject.isRequired,
    museum: MobXPropTypes.observableObject.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.reset()
    if (this.props.auth.acs.isAuthorized('ADMIN')) {
      this.props.museum.loadPublic()
    }
  }

  @observable formData = getDefaults()

  @observable message = ''

  @observable isBusy = false

  @autobind
  handleChange({
    target: {
      name, value, checked, type
    }
  }) {
    const val = type === 'checkbox' ? checked : value
    this.formData[name] = val
  }

  reset() {
    this.formData = getDefaults()
    const isAdmin = this.props.auth.acs.isAuthorized('ADMIN')
    if (!isAdmin) {
      this.formData = { ...this.formData, recipient: 'Administrator' }
    }
    this.message = ''
  }

  @autobind
  handleCancel(e) {
    e.preventDefault()
    this.close()
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()
    this.isBusy = true
    const data = toJS(this.formData)
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    fetch(`${window.APP_CONFIG.API_URL}private/contact`, {
      credentials: 'include',
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data),
      headers
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((err) => {
            throw new Error(`Error: ${err.message}`)
          })
        }
        return null
      })
      .then(() => {
        this.reset()
        this.message = 'Nachricht verschickt.'
        setTimeout(() => {
          this.message = ''
        }, 10000)
        this.isBusy = false
      })
      .catch((ex) => {
        this.message = ex.message
        this.formData = data
        this.isBusy = false
      })

  }

  close() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {
    const { auth, museum: museumStore } = this.props
    const isAdmin = auth.acs.isAuthorized('ADMIN')
    const user = auth.user
    const districtId = user.districtId

    const museums = museumStore.collection.filter((museum) => {
      if (districtId && museum.districtId !== districtId) {
        return false
      }
      return true
    })

    const regions = window.APP_CONFIG.districts.filter((region) => {
      if (!region.active) {
        return false
      }
      if (districtId && region.id !== districtId) {
        return false
      }
      return true
    })

    return (
      <div className="container message-reply">
        <form className="form form-horizontal"
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        >
          <div className="form-group" style={{ textAlign: 'center' }}>
            {this.message}
          </div>
          <div className="form-group">
            <label
              className="col-xs-2"
              htmlFor="recipient"
            >
              Empfänger
            </label>

            <div className="col-xs-10">
              {isAdmin
                ? (
                  <select
                    className="form-control"
                    id="recipient"
                    name="recipient"
                    value={this.formData.recipient}
                    disabled={this.isBusy}
                  >
                    <option value="Support">Support</option>

                    <optgroup label="Regionen">
                      {regions.map((region) => (
                        <option
                          key={region.id}
                          value={`region:${region.id}`}
                        >
                          {region.name}
                        </option>
                      ))}
                    </optgroup>

                    <optgroup label="Museen">
                      {museumStore.loading ? (<option disabled>Museen werden geladen...</option>) : museums.map((museum) => (
                        <option
                          key={museum.id}
                          value={`museum:${museum.id}`}
                        >
                          {museum.name}
                        </option>
                      ))}
                    </optgroup>

                  </select>
                )
                : (
                  <input className="form-control"
                    readOnly
                    disabled={this.isBusy}
                    type="text"
                    id="recipient"
                    name="recipient"
                    value={this.formData.recipient}
                  />
                )}

              {isAdmin && museumStore.loading ? (
                <div className="help-block">
                  Museen werden geladen...
                </div>
              ) : null}
            </div>
          </div>
          <div className="form-group">
            <label
              className="col-xs-2"
              htmlFor="subject"
            >
              Betreff
            </label>
            <div className="col-xs-10">
              <input
                className="form-control"
                type="text"
                name="subject"
                value={this.formData.subject}
                disabled={this.isBusy}
              />
            </div>
          </div>
          <div className="form-group">
            <label
              className="col-xs-2"
              htmlFor="message"
            >
              Nachricht
            </label>
            <div className="col-xs-10">
              <textarea
                className="form-control"
                id="message"
                name="message"
                value={this.formData.message}
                required
                disabled={this.isBusy}
              />
            </div>
          </div>
          <div className="form-group">
            <div
              className="col-xs-10 col-xs-offset-2"
            >
              <Button
                className="action btn btn-primary"
                type="submit"
                busy={this.isBusy}
              >
                Abschicken
              </Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export { FormPage as default }



// WEBPACK FOOTER //
// ./src/message/components/FormPage.js